import { writable, get, Writable } from "svelte/store";

export interface ChatMessage {
  id: string,
  senderId: string,
  timestamp: number,
  header: string,
  body: string,
  imageUrl: string,
  admin: boolean
}

export const myMessages: Writable<ChatMessage[]> = writable([]);

export function pushMessage(message: ChatMessage) {
  let arr = get(myMessages);
  arr.push(message);
  myMessages.set(arr);
}
